type ErrorFields = {
  name?: unknown;
  message?: unknown;
  cause?: unknown;
  stack?: unknown;
};

export function errorToFields(error: ErrorFields) {
  const errorObject: ErrorFields = {
    name: error?.name,
    message: error?.message,
    cause: error?.cause,
    stack: error?.stack,
  };

  // If we don't have an error object, still try to embed whatever was caught
  if (Object.values(errorObject).every((x) => x === undefined)) {
    return error;
  }
  return errorObject;
}
